// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"ffe2cedf","21":"a24cee87","61":"9dac2ad2","127":"11ede03f","218":"f92d75ee","401":"aaf85999","407":"25a99f06","469":"6d8579a4","637":"880bed1b","761":"963f50fb","763":"e502af49","980":"12894124"}[chunkId] + ".chunk.js";
};